import type { ProductInformation } from '@hotjar/product-catalog';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { convertReadableNumber } from '~/subscription-management/utils/allowance.utils';

interface Props {
  productInfo?: ProductInformation;
}

export function PlanName({ productInfo }: Props): JSX.Element | null {
  const { t: tProductInformation } = useTranslationWithPrefix('checkout:product-information');

  if (!productInfo) {
    return null;
  }

  const { name } = productInfo.plan;

  return (
    <>
      {tProductInformation(`plan.${name}`)}

      {/* As business plans have multiple allowance options, we also display those here. */}
      {name === 'business' && (
        <>
          {'dailyCcSessions' in productInfo.allowance && (
            <span> {convertReadableNumber(productInfo.allowance.dailyCcSessions)}</span>
          )}
          {'monthlyResponses' in productInfo.allowance && (
            <span> {convertReadableNumber(productInfo.allowance.monthlyResponses)}</span>
          )}
        </>
      )}
    </>
  );
}
